export const getCommonPiFormStyles = ({ palette }) => ({
  global: {
    '@global': {
      '.sca-challenger-dialog': {
        '& .modal-content': {
          minWidth: 650,
          '@media (max-width:600px)': {
            minWidth: 400,
          },

          '& .pidlddc-iFrame': {
            height: '490px !important',
            '@media (max-width:600px)': {
              width: '355px !important',
              height: '530px !important',
            },
          },
        },
      },
    },
  },
  sDisplayMode: {
    '& .pi-type-input': {
      marginRight: 8,
    },
    '& .country-input': {
      marginRight: 8,
    },
    '& .payment-type-input': {
      marginRight: 8,
    },
    '& .addFundsForm': {
      marginRight: 8,
    },
    '@global': {
      '.sca-challenger-dialog': {
        '& .modal-content': {
          minWidth: 400,

          '& .pidlddc-iFrame': {
            width: '355px !important',
            height: '530px !important',
          },
        },
      },
    },
  },
  common: {
    '& .col-xs-6': {
      width: '100%',
    },
    '& .pi-type-input': {
      marginRight: 22,
    },
    '& .country-input': {
      marginRight: 22,
    },
    '& .payment-type-input': {
      marginRight: 22,
    },
    '& .addFundsForm': {
      marginRight: 22,
    },
    '& .pi-type-selector-container': {
      '& > .form-group > .col-xs-6.form-control-container': {
        paddingRight: 15,
      },
    },
    '& .form-control': {
      height: 32,
      fontSize: 14,
      padding: '3px 15px',
    },
    '& .pidlddc-error': {
      color: '#A80000',
      position: 'relative',
      float: 'left',
      width: '100%',
      minHeight: 1,
      margin: 0,
      padding: '4px 0 0 5px',
      fontSize: 12,
    },
    '& .pidlddc-input-property': {
      height: 25,
      fontSize: 14,
      lineHeight: '1.45833333',
      color: '#333',
      verticalAlign: 'middle',
      backgroundColor: palette.white,
      backgroundImage: 'none',
      border: '1px solid #bbb',
      position: 'relative',
      float: 'left',
      width: '50%',
      minHeight: 1,
      padding: '3px 15px',
      '&:focus': {
        outline: `1px solid ${palette.themePrimary}`,
        outlineOffset: '-1px',
      },
    },
    '& .adder-pidl-form-container': {
      paddingRight: 0,
    },
    '& .pidlddc-div': {
      marginBottom: 0,
    },
    '& .pidlddc-div-logo': {
      display: 'none',
    },
    '& .piid-selector-container': {
      '& .form-group': {
        marginRight: '-7px',
      },
    },
    '& .pidlddc-input-cardNumber': {
      height: 32,
      width: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'right',
      border: '1px solid #bbbbbb',
    },
    '& .pidlddc-input-cardNumberAmex': {
      height: 32,
      width: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'right',
      border: '1px solid #bbbbbb',
    },
    '& .pidlddc-div .pidlddc-div-group .pidlddc-group-inline': {
      marginTop: 10,
    },
    '& #pidlddc-label-pidlddc-div-expiryGroup': {
      marginTop: 37,
    },
    '& .pidlddc-div-cvv': {
      marginTop: 5,
    },
    '& .pidlddc-input-cvvToken': {
      width: '48%',
      height: 32,
    },
    '& .pidlddc-help-imageLink': {
      marginLeft: 16,
      marginTop: 5,
    },
    '& .pidlddc-div-cardholderName': {
      marginTop: 12,
    },
    '& .pidlddc-input-accountHolderName': {
      width: '100%',
      height: 32,
    },
    '& .pidlddc-input-prefillAddressDropdown': {
      width: '100%',
      height: 32,
    },
    '& .pidlddc-input-addressLine1': {
      width: '100%',
      height: 32,
      marginTop: 12,
    },
    '& .pidlddc-input-addressLine2 ': {
      width: '100%',
      height: 32,
      marginTop: 12,
    },
    '& .pidlddc-input-addressCity': {
      width: '100%',
      height: 32,
      marginTop: 12,
    },
    '& .pidlddc-input-addressState': {
      width: '100%',
      height: 32,
      marginTop: 12,
    },
    '& .pidlddc-input-addressProvince': {
      width: '100%',
      height: 32,
      marginTop: 12,
    },
    '& .pidlddc-input-addressCounty': {
      width: '100%',
      height: 32,
      marginTop: 12,
    },
    '& .pidlddc-input-addressPostalCode': {
      width: 210,
      height: 32,
      marginTop: 12,
      marginBottom: 16,
      '& +.pidlddc-error': {
        margin: '-16px 0 12px 0',
      },
    },
    '& .pidlddc-address-group': {
      marginTop: 37,
      display: 'block',
    },
    '& .pidlddc-div-cardNumber': {
      marginBottom: 12,
    },
    '& .pidlddc-inline-element-0': {
      display: 'inline',
    },
    '& .pidlddc-inline-element-1': {
      display: 'inline',
    },
    '& .pidlddc-group-inline .pidlddc-div-expiryMonth': {
      paddingRight: 0,
      width: '48%',
      display: 'inline-block',
      verticalAlign: 'top',
    },
    '& .pidlddc-input-expiryMonth': {
      height: 32,
      width: '100%',
      border: '1px solid #bbbbbb',
    },
    '& .pidlddc-group-inline .pidlddc-div-expiryYear': {
      width: '48%',
      marginLeft: '4%',
      paddingLeft: 0,
      display: 'inline-block',
      verticalAlign: 'top',
    },
    '& .pidlddc-input-expiryYear': {
      height: 32,
      width: '100%',
      border: '1px solid #bbbbbb',
    },
    '& .form-group': {
      marginTop: 5,
      marginBottom: 5,
    },
    '& .pidlddc-help-dialog-block': {
      display: 'none',
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      width: '90%',
      overflow: 'visible',
      textAlign: 'center',
    },
    '& .pidlddc-help-dialog-content-block': {
      position: 'absolute',
      padding: '10px 15px 20px 15px',
      width: '90%',
      backgroundColor: palette.white,
      border: '1px solid #ccc',
      lineHeight: '20px',
      color: '#4f4f4f',
      zIndex: '1000',
      textTransform: 'none',
      textAlign: 'left',
      whiteSpace: 'normal',
      marginTop: '40%',
    },
    '& .pidlddc-help-dialog-close': {
      position: 'absolute',
      right: 10,
      top: 10,
      backgroundColor: 'transparent',
      cursor: 'pointer',
      padding: 0,
      border: 0,
      fontSize: 18,
      fontWeight: 'bold',
      color: '#666',
      outline: 'none',
    },
    '& .offline-pi-section': {
      '& .alert-spacing': {
        marginRight: '-7px',
      },
      '& .section-group-check-instruction, & .section-group-wire-instruction': {
        '& .page-header': {
          marginLeft: 15,
        },
        '& .section-body': {
          '& .col-xs-3': {
            width: '100%',
          },
        },
      },
    },
    '& .error': {
      fontSize: 12,
      color: '#A80000',
    },
    '& label .helpbutton': {
      fontWeight: 'normal',
      display: 'inline-block',
    },
    '& .auto-recharge-toggle': {
      marginBottom: 4,
    },
  },
  // TODO: Merge with Common once PIDLTemplates GA'ed
  pidlMigration: {
    '& .pidlddc-input-property': {
      float: 'none',
    },
    '& .pidlddc-div-cvv': {
      marginTop: 0,
    },
    '& .pidlddc-input-cvvToken': {
      verticalAlign: 'middle',
    },
    '& .pidlddc-help-imageLink': {
      verticalAlign: 'middle',
      marginTop: 0,
    },
    '& .pidlddc-input-addressLine1': {
      marginTop: 0,
    },
    '& .pidlddc-input-addressLine2 ': {
      marginTop: 0,
    },
    '& .pidlddc-input-addressCity': {
      marginTop: 0,
    },
    '& .pidlddc-input-addressState': {
      marginTop: 0,
    },
    '& .pidlddc-input-addressCounty': {
      marginTop: 0,
    },
    '& .pidlddc-input-addressProvince': {
      marginTop: 0,
    },
    '& .pidlddc-input-addressPostalCode': {
      marginTop: 0,
      marginBottom: 0,
      '& + .pidlddc-error': {
        margin: 0,
      },
    },
    '& .pidlddc-address-group': {
      marginTop: 0,
    },
    '& .pidlddc-div-cardNumber': {
      marginBottom: 0,
    },
    '& #pidlddc-div-acceptedVisaCardGroup,#pidlddc-div-acceptedAmexCardGroup,#pidlddc-div-acceptedMCCardGroup,#pidlddc-div-acceptedDiscoverCardGroup,#pidlddc-div-acceptedJCBCardGroup': {
      display: 'flex',
      alignItems: 'center',
      marginTop: 19,
      '& .pidlddc-static-text.pidlddc-text': {
        marginBottom: 0,
      },
    },
    '& .pidlddc-div-logo.pidlddc-logoBlock': {
      display: 'flex',
      '& img': {
        height: 20,
        marginLeft: 5,
      },
    },
    '& #pidlddc-div-cvvGroup': {
      position: 'relative',
    },
    '& .pidlddc-help-dialog-content-block': {
      marginTop: 0,
      // card help dialog height
      top: -240,
    },
    '& #pidlddc-text-paymentOptionSaveText': {
      marginTop: 10,
    },
    '& .pidlddc-text-group.pidlddc-privacy-text-group': {
      marginBottom: 0,
    },
    '& .pidlddc-label': {
      padding: '10px 0 5px',
    },
    '& .pidlddc-div-cardholderName': {
      marginTop: 4,
    },
    '& #pidlddc-text-paypalHeading': {
      display: 'none',
    },
    '& #pidlddc-text-paypalHeading ~ #pidlddc-text-microsoftPrivacyTextGroup': {
      paddingBottom: 4,
    },
    '& .pidlddc-error': {
      float: 'none',
      display: 'block',
    },
    '& #pidlddc-text-paypalInstructionTextGroup': {
      display: 'flex',
      backgroundColor: '#eff6fc',
      borderColor: '#eff6fc',
      color: '#323130',
      padding: '8px 32px 8px 8px',
      fontSize: 12,
      lineHeight: '16px',
      marginTop: '-5px',
    },
    '& #pidlddc-text-paypalInstructionTextGroup::before': {
      content: '"\\f12c"',
      fontFamily: '"BingAds UI Icons"',
      fontSize: 12,
      lineHeight: 1,
      color: '#605e5c',
      display: 'inline-block',
      fontWeight: 'normal',
      fontStyle: 'normal',
      speak: 'none',
      textDecoration: 'inherit',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      margin: '2px 8px 0 0',
    },
    '& #pidlddc-text-paymentSummaryText': {
      display: 'none',
    },
    '& #pidlddc-iFrame-ChallengeFrame': {
      border: 'none',
      marginTop: 10,
    },
  },
});

